import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';

// Use env vars if provided; otherwise fall back to the supplied config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyBc9t7MfQbOAfGlRrKgIuX6ko6LFEI1t5s',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'avisdatabse.firebaseapp.com',
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || 'https://avisdatabse-default-rtdb.firebaseio.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'avisdatabse',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'avisdatabse.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '602050887655',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:602050887655:web:a1713dc804575206e18742',
  measurementId: (process.env.REACT_APP_FIREBASE_MEASUREMENT_ID as string) || 'G-DXPZ7YF9LK',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Initialize analytics if supported (no-op on unsupported environments)
isSupported().then((ok) => {
  if (ok) getAnalytics(app);
});

// Initialize authentication - handle anonymous auth failure gracefully
const auth = getAuth(app);

// Create a promise that resolves immediately for Firestore access
// Anonymous auth may fail due to Firebase security settings, but Firestore can still work
export const authReady: Promise<void> = new Promise((resolve) => {
  // Resolve immediately to not block app initialization
  resolve();

  // Try anonymous auth in background
  signInAnonymously(auth).catch((e) => {
    // eslint-disable-next-line no-console
    console.warn('Anonymous auth failed - this is expected in some Firebase configurations:', e.message);
    console.log('App will continue to work with limited authentication features');
  });
});

export { auth };


